import { render, staticRenderFns } from "./ChildrenImage.vue?vue&type=template&id=048a6529&"
import script from "./ChildrenImage.vue?vue&type=script&lang=js&"
export * from "./ChildrenImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports